import IMAdjustmentModal from './IMAdjustmentModal';

export default IMAdjustmentModal;
